import { render, staticRenderFns } from "./Categories.vue?vue&type=template&id=3e8ea0ac&scoped=true"
import script from "./Categories.vue?vue&type=script&lang=js"
export * from "./Categories.vue?vue&type=script&lang=js"
import style0 from "./Categories.vue?vue&type=style&index=0&id=3e8ea0ac&prod&scoped=true&lang=css"
import style1 from "./Categories.vue?vue&type=style&index=1&id=3e8ea0ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e8ea0ac",
  null
  
)

export default component.exports